import apisauce from "apisauce";

const apiClient = apisauce.create({
  baseURL: "https://api.carota.org"
  // baseURL: "http://localhost:3000"
});

export const setApiToken = token => {
  apiClient.setHeader("Authorization", `Bearer ${token}`);
};

export default apiClient;
